import "./reviews.scss";
import one from "./assets/one.png";
import two from "./assets/two.png";
import three from "./assets/three.png";
import four from "./assets/four.png";
import five from "./assets/five.png";
import six from "./assets/six.png";
import seven from "./assets/seven.png";
import eight from "./assets/eight.png";
import resulted from "../casestudy/assets/resulted-in.png";
import engagement from "../casestudy/assets/engagement.png";
import impressions from "../casestudy/assets/impressions.png";
import { fade, childFade } from "../fade.js";
import { motion } from "framer-motion";

const Reviews = ({ novid }) => {
  return (
    <motion.section
      class="section reviews"
      variants={fade}
      initial="hide"
      whileInView="show"
      viewport={{ once: true }}
    >
      {novid && (
        <>
          <motion.div
            className="row full novid"
            key="row-6"
            variants={childFade}
          >
            <img src={resulted} alt="review" />
          </motion.div>
          <motion.div
            className="row novid-small"
            key="row-7"
            variants={childFade}
          >
            <img src={impressions} alt="review" className="imp" />
            <img src={engagement} alt="review" className="eng" />
          </motion.div>
        </>
      )}
      <motion.div className="row off" key="row-1" variants={childFade}>
        <img src={seven} alt="review" className="seven" />
        <img src={five} alt="review" className="five" />
      </motion.div>
      <motion.div className="row full" key="row-2" variants={childFade}>
        <img src={four} alt="review" className="prof" />
      </motion.div>
      <motion.div className="row" key="row-3" variants={childFade}>
        <img src={eight} alt="review" className="eight" />
        <img src={six} alt="review" className="six" />
      </motion.div>
      <motion.div className="row full" key="row-4" variants={childFade}>
        <img src={three} alt="review" />
      </motion.div>
      <motion.div className="row" key="row-5" variants={childFade}>
        <img src={two} alt="review" />
        <img src={one} alt="review" />
      </motion.div>
    </motion.section>
  );
};

export default Reviews;
